export enum TypeForm {
  BASIC,
}
